import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../../components/ui/Header';
import Breadcrumb from '../../components/ui/Breadcrumb';
import HeroSection from './components/HeroSection';
import BrandsSection from './components/BrandsSection';
import JeskoHero from './components/JeskoHero';
import XiaomiSection from './components/XiaomiSection';
import ExpertiseSection from './components/ExpertiseSection';
import { initSmoothScroll } from '../../utils/smoothScroll';
import SEO from '../../components/SEO'; // ISPRAVLJENO: ../../

const HomepageHeroServices = () => {
  const { t } = useTranslation('home');
  
  useEffect(() => {
    initSmoothScroll();
  }, []);
  
  return (
    <>
      <SEO 
        titleKey="home.title" 
        descriptionKey="home.description" 
        pagePath="" // Prazno jer je početna
      />

      <div className="flex min-h-screen flex-col bg-background">
        <Header />
        <main className="pt-header flex-grow">
          {/* Breadcrumb obično ne ide na početnu, ali ako ga želiš, tu je */}
          <div className="px-6 lg:px-8">
            <Breadcrumb />
          </div>

          <HeroSection />
          <BrandsSection />
          <ExpertiseSection />
          <JeskoHero />
          <XiaomiSection />
        </main>
      </div>
    </>
  );
};

export default HomepageHeroServices;